export interface ErrorDto {
  status: number;
  path: string;
  message: string;
}

export const ErrorGeneric: ErrorDto = {
  status: 500,
  path: '',
  message: 'Something went wrong',
}

export const getErrorDtoFromApiError = (error: any): ErrorDto => {
  if (!error.response || !error.response.data) {
    return ErrorGeneric;
  }
  return error.response.data;
}
